(function(config) {
    'use strict';

    angular.module('tags.services', [
            'ngResource'
        ])
        .factory('tagsDataSrvc', tagsDataSrvc)
        .factory('tagsSrvc', tagsSrvc);

    tagsDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function tagsDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/tags/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            },
            getFieldOpts: {
                method: 'GET',
                url: config.api + '/api/v1/tags/form_field_opts/',
                isArray: true
            }
        });
    }

    tagsSrvc.$inject = ['tagsDataSrvc', 'modalSrvc'];

    function tagsSrvc(tagsDataSrvc, modalSrvc) {
        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    tagsDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }
})(window.config);
